(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["MaskedInput"] = factory(require("react"));
	else
		root["MaskedInput"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _inputmaskCore = __webpack_require__(3);
	
	var _inputmaskCore2 = _interopRequireDefault(_inputmaskCore);
	
	var KEYCODE_Z = 90;
	var KEYCODE_Y = 89;
	
	function isUndo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
	}
	
	function isRedo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
	}
	
	function getSelection(el) {
	  var start, end, rangeEl, clone;
	
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      rangeEl = el.createTextRange();
	      clone = rangeEl.duplicate();
	
	      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {/* not focused or not visible */}
	  }
	
	  return { start: start, end: end };
	}
	
	function setSelection(el, selection) {
	  var rangeEl;
	
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(selection.start, selection.end);
	    } else {
	      el.focus();
	      rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', selection.start);
	      rangeEl.moveEnd('character', selection.end - selection.start);
	      rangeEl.select();
	    }
	  } catch (e) {/* not focused or not visible */}
	}
	
	var MaskedInput = (function (_React$Component) {
	  _inherits(MaskedInput, _React$Component);
	
	  function MaskedInput(props) {
	    _classCallCheck(this, MaskedInput);
	
	    _get(Object.getPrototypeOf(MaskedInput.prototype), 'constructor', this).call(this, props);
	    var options = {
	      pattern: props.mask,
	      value: props.value,
	      formatCharacters: props.formatCharacters
	    };
	    if (props.placeholderChar) {
	      options.placeholderChar = props.placeholderChar;
	    }
	    if (props.isRevealingMask) {
	      options.isRevealingMask = props.isRevealingMask;
	    }
	    this.mask = new _inputmaskCore2['default'](options);
	  }
	
	  _createClass(MaskedInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.mask) {
	        if (this.props.mask !== nextProps.mask && this.props.value !== nextProps.mask) {
	          // if we get a new value and a new mask at the same time
	          // check if the mask.value is still the initial value
	          // - if so use the nextProps value
	          // - otherwise the `this.mask` has a value for us (most likely from paste action)
	          if (this.mask.getValue() === this.mask.emptyValue) {
	            this.mask.setPattern(nextProps.mask, { value: nextProps.value });
	          } else {
	            this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	          }
	        } else if (this.props.mask !== nextProps.mask) {
	          this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	        } else if (this.props.value !== nextProps.value) {
	          this.mask.setValue(nextProps.value);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextProps.mask !== this.props.mask) {
	        this._updatePattern(nextProps);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.mask) {
	        if (prevProps.mask !== this.props.mask && this.mask.selection.start || prevProps.value !== this.props.value) {
	          this._updateInputSelection();
	        }
	      }
	    }
	  }, {
	    key: '_updatePattern',
	    value: function _updatePattern(props) {
	      if (this.mask) {
	        this.mask.setPattern(props.mask, {
	          value: this.mask.getRawValue(),
	          selection: getSelection(this.input)
	        });
	      }
	    }
	  }, {
	    key: '_updateMaskSelection',
	    value: function _updateMaskSelection() {
	      if (this.mask) {
	        this.mask.selection = getSelection(this.input);
	      }
	    }
	  }, {
	    key: '_updateInputSelection',
	    value: function _updateInputSelection() {
	      if (this.mask) {
	        setSelection(this.input, this.mask.selection);
	      }
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(e) {
	      if (this.mask) {
	        var maskValue = this.mask.getValue();
	        if (e.target.value !== maskValue) {
	          // Cut or delete operations will have shortened the value
	          if (e.target.value.length < maskValue.length) {
	            var sizeDiff = maskValue.length - e.target.value.length;
	            this._updateMaskSelection();
	            this.mask.selection.end = this.mask.selection.start + sizeDiff;
	            this.mask.backspace();
	          }
	          var value = this._getDisplayValue();
	          e.target.value = value;
	          if (value) {
	            this._updateInputSelection();
	          }
	        }
	        this._updateValue(e);
	      }
	    }
	  }, {
	    key: '_onKeyDown',
	    value: function _onKeyDown(e) {
	      if (this.mask) {
	        if (isUndo(e)) {
	          e.preventDefault();
	          if (this.mask.undo()) {
	            e.target.value = this._getDisplayValue();
	            this._updateInputSelection();
	            this._updateValue(e);
	          }
	          return;
	        } else if (isRedo(e)) {
	          e.preventDefault();
	          if (this.mask.redo()) {
	            e.target.value = this._getDisplayValue();
	            this._updateInputSelection();
	            this._updateValue(e);
	          }
	          return;
	        }
	
	        if (e.key === 'Backspace') {
	          e.preventDefault();
	          this._updateMaskSelection();
	          if (this.mask.backspace()) {
	            var value = this._getDisplayValue();
	            e.target.value = value;
	            if (value) {
	              this._updateInputSelection();
	            }
	            this._updateValue(e);
	          }
	        }
	      }
	    }
	  }, {
	    key: '_onKeyPress',
	    value: function _onKeyPress(e) {
	      if (this.mask) {
	        if (e.metaKey || e.altKey || e.ctrlKey || e.key === 'Enter') {
	          return;
	        }
	
	        e.preventDefault();
	        this._updateMaskSelection();
	        if (this.mask.input(e.key || e.data)) {
	          e.target.value = this.mask.getValue();
	          window.mask = this.mask;
	          this._updateInputSelection();
	          this._updateValue(e);
	        }
	      }
	    }
	  }, {
	    key: '_onPaste',
	    value: function _onPaste(e) {
	      if (this.mask) {
	        e.preventDefault();
	        this._updateMaskSelection();
	        // getData value needed for IE also works in FF & Chrome
	        if (this.mask.paste(e.clipboardData.getData('Text'))) {
	          e.target.value = this.mask.getValue();
	          // Timeout needed for IE
	          setTimeout(this._updateInputSelection, 0);
	          this._updateValue(e);
	        }
	      }
	    }
	  }, {
	    key: '_updateValue',
	    value: function _updateValue(e) {
	      if (this.mask) {
	        this.mask.setValue(this.mask.getValue());
	        if (this.props.onChange) {
	          this.props.onChange(e, this.mask);
	        }
	      }
	    }
	  }, {
	    key: '_getDisplayValue',
	    value: function _getDisplayValue() {
	      if (this.mask) {
	        var value = this.mask.getValue();
	        return value === this.mask.emptyValue ? '' : value;
	      }
	    }
	  }, {
	    key: '_keyPressPropName',
	    value: function _keyPressPropName() {
	      if (typeof navigator !== 'undefined') {
	        return navigator.userAgent.match(/Android/i) ? 'onBeforeInput' : 'onKeyPress';
	      }
	      return 'onKeyPress';
	    }
	  }, {
	    key: '_getEventHandlers',
	    value: function _getEventHandlers() {
	      var _this = this;
	
	      return _defineProperty({
	        onChange: function onChange(e) {
	          return _this._onChange(e);
	        },
	        onKeyDown: function onKeyDown(e) {
	          return _this._onKeyDown(e);
	        },
	        onPaste: function onPaste(e) {
	          return _this._onPaste(e);
	        }
	      }, this._keyPressPropName(), function (e) {
	        return _this._onKeyPress(e);
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var ref = function ref(r) {
	        _this2.input = r;
	      };
	      var maxLength = this.mask.pattern.length;
	      var value = this._getDisplayValue();
	      var eventHandlers = this._getEventHandlers();
	      var _props = this.props;
	      var _props$size = _props.size;
	      var size = _props$size === undefined ? maxLength : _props$size;
	      var _props$placeholder = _props.placeholder;
	      var placeholder = _props$placeholder === undefined ? this.mask.emptyValue : _props$placeholder;
	      var _props2 = this.props;
	      var placeholderChar = _props2.placeholderChar;
	      var formatCharacters = _props2.formatCharacters;
	      var isRevealingMask = _props2.isRevealingMask;
	
	      var cleanedProps = _objectWithoutProperties(_props2, ['placeholderChar', 'formatCharacters', 'isRevealingMask']);
	
	      var inputProps = _extends({}, cleanedProps, eventHandlers, { ref: ref, maxLength: maxLength, value: value, size: size, placeholder: placeholder });
	      return _react2['default'].createElement('input', inputProps);
	    }
	  }]);
	
	  return MaskedInput;
	})(_react2['default'].Component);
	
	exports.MaskedInput = MaskedInput;
	
	MaskedInput.propTypes = {
	  mask: _propTypes2['default'].string.isRequired,
	  formatCharacters: _propTypes2['default'].object,
	  placeholderChar: _propTypes2['default'].string
	};
	
	MaskedInput.defaultProps = {
	  value: ''
	};
	
	var styles = {
	  maskedWrapper: {
	    position: 'relative',
	    width: '100%',
	    display: 'inline-block'
	  },
	  maskedInput: {
	    background: 'transparent',
	    zIndex: '10'
	  },
	  maskedPlaceholder: {
	    position: 'absolute',
	    width: '100%',
	    left: '0',
	    top: '0',
	    zIndex: '-1'
	  },
	  hide: {
	    display: 'none'
	  }
	};
	
	var MaskedInputFixed = (function (_React$Component2) {
	  _inherits(MaskedInputFixed, _React$Component2);
	
	  function MaskedInputFixed(props) {
	    _classCallCheck(this, MaskedInputFixed);
	
	    _get(Object.getPrototypeOf(MaskedInputFixed.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      val: ''
	    };
	  }
	
	  _createClass(MaskedInputFixed, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.value) {
	        this.setState({
	          val: this.props.value
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value || nextProps.controlled && nextProps.value === '') {
	        this.setState({
	          val: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(e, mask) {
	      var val = mask.getRawValue();
	      var placeholderChar = this.props.placeholderChar;
	      var arrVal = val.split(placeholderChar);
	      var newRawVal = arrVal.join('');
	      mask.setValue(newRawVal);
	      var finalVal = mask.getValue();
	      var newE = _extends({}, e, {
	        target: _extends({}, e.target, {
	          value: finalVal
	        })
	      });
	      this.setState({
	        val: finalVal
	      });
	      this.props.onChange(newE);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props;
	      var showPlaceholder = _props3.showPlaceholder;
	      var placeholderFixed = _props3.placeholderFixed;
	      var hidePlaceholder = _props3.hidePlaceholder;
	      var _props3$className = _props3.className;
	      var className = _props3$className === undefined ? '' : _props3$className;
	      var _props3$classWrapper = _props3.classWrapper;
	      var classWrapper = _props3$classWrapper === undefined ? '' : _props3$classWrapper;
	      var _props3$classPlaceholder = _props3.classPlaceholder;
	      var classPlaceholder = _props3$classPlaceholder === undefined ? '' : _props3$classPlaceholder;
	      var onChange = _props3.onChange;
	
	      var filteredProps = _objectWithoutProperties(_props3, ['showPlaceholder', 'placeholderFixed', 'hidePlaceholder', 'className', 'classWrapper', 'classPlaceholder', 'onChange']);
	
	      var placeholderChar = filteredProps.placeholderChar;
	      var isRevealingMask = filteredProps.isRevealingMask;
	
	      var filteredPropsforInput = _objectWithoutProperties(filteredProps, ['placeholderChar', 'isRevealingMask']);
	
	      var fixedPlaceholder = this.state.val.concat(placeholderFixed.slice(this.state.val.length));
	
	      return _react2['default'].createElement(
	        'div',
	        { className: classWrapper, style: styles.maskedWrapper },
	        _react2['default'].createElement(MaskedInput, _extends({}, filteredProps, {
	          onChange: function (e, mask) {
	            _this3._onChange(e, mask);
	          },
	          value: this.state.val,
	          ref: function (r) {
	            return _this3.input = r && r.input;
	          },
	          className: className,
	          style: styles.maskedInput })),
	        _react2['default'].createElement('input', _extends({}, filteredPropsforInput, {
	          value: fixedPlaceholder,
	          style: hidePlaceholder ? _extends({}, styles.maskedPlaceholder, styles.hide) : styles.maskedPlaceholder,
	          className: classPlaceholder,
	          disabled: true }))
	      );
	    }
	  }]);
	
	  return MaskedInputFixed;
	})(_react2['default'].Component);
	
	exports.MaskedInputFixed = MaskedInputFixed;
	
	MaskedInputFixed.defaultProps = {
	  placeholderChar: ' ',
	  isRevealingMask: true
	};
	
	var MaskedSwitch = (function (_React$Component3) {
	  _inherits(MaskedSwitch, _React$Component3);
	
	  function MaskedSwitch() {
	    _classCallCheck(this, MaskedSwitch);
	
	    _get(Object.getPrototypeOf(MaskedSwitch.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(MaskedSwitch, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return this.props.placeholderFixed ? _react2['default'].createElement(MaskedInputFixed, _extends({}, this.props, { ref: function (r) {
	          return _this4.input = r && r.input;
	        } })) : _react2['default'].createElement(MaskedInput, _extends({}, this.props, { ref: function (r) {
	          return _this4.input = r && r.input;
	        } }));
	    }
	  }]);
	
	  return MaskedSwitch;
	})(_react2['default'].Component);
	
	MaskedSwitch.propTypes = {
	  mask: _propTypes2['default'].string.isRequired,
	  formatCharacters: _propTypes2['default'].object,
	  placeholderChar: _propTypes2['default'].string
	};
	
	exports['default'] = MaskedSwitch;

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict'
	
	function extend(dest, src) {
	  if (src) {
	    var props = Object.keys(src)
	    for (var i = 0, l = props.length; i < l ; i++) {
	      dest[props[i]] = src[props[i]]
	    }
	  }
	  return dest
	}
	
	function copy(obj) {
	  return extend({}, obj)
	}
	
	/**
	 * Merge an object defining format characters into the defaults.
	 * Passing null/undefined for en existing format character removes it.
	 * Passing a definition for an existing format character overrides it.
	 * @param {?Object} formatCharacters.
	 */
	function mergeFormatCharacters(formatCharacters) {
	  var merged = copy(DEFAULT_FORMAT_CHARACTERS)
	  if (formatCharacters) {
	    var chars = Object.keys(formatCharacters)
	    for (var i = 0, l = chars.length; i < l ; i++) {
	      var char = chars[i]
	      if (formatCharacters[char] == null) {
	        delete merged[char]
	      }
	      else {
	        merged[char] = formatCharacters[char]
	      }
	    }
	  }
	  return merged
	}
	
	var ESCAPE_CHAR = '\\'
	
	var DIGIT_RE = /^\d$/
	var LETTER_RE = /^[A-Za-z]$/
	var ALPHANNUMERIC_RE = /^[\dA-Za-z]$/
	
	var DEFAULT_PLACEHOLDER_CHAR = '_'
	var DEFAULT_FORMAT_CHARACTERS = {
	  '*': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) }
	  },
	  '1': {
	    validate: function(char) { return DIGIT_RE.test(char) }
	  },
	  'a': {
	    validate: function(char) { return LETTER_RE.test(char) }
	  },
	  'A': {
	    validate: function(char) { return LETTER_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  },
	  '#': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  }
	}
	
	/**
	 * @param {string} source
	 * @patam {?Object} formatCharacters
	 */
	function Pattern(source, formatCharacters, placeholderChar, isRevealingMask) {
	  if (!(this instanceof Pattern)) {
	    return new Pattern(source, formatCharacters, placeholderChar)
	  }
	
	  /** Placeholder character */
	  this.placeholderChar = placeholderChar || DEFAULT_PLACEHOLDER_CHAR
	  /** Format character definitions. */
	  this.formatCharacters = formatCharacters || DEFAULT_FORMAT_CHARACTERS
	  /** Pattern definition string with escape characters. */
	  this.source = source
	  /** Pattern characters after escape characters have been processed. */
	  this.pattern = []
	  /** Length of the pattern after escape characters have been processed. */
	  this.length = 0
	  /** Index of the first editable character. */
	  this.firstEditableIndex = null
	  /** Index of the last editable character. */
	  this.lastEditableIndex = null
	  /** Lookup for indices of editable characters in the pattern. */
	  this._editableIndices = {}
	  /** If true, only the pattern before the last valid value character shows. */
	  this.isRevealingMask = isRevealingMask || false
	
	  this._parse()
	}
	
	Pattern.prototype._parse = function parse() {
	  var sourceChars = this.source.split('')
	  var patternIndex = 0
	  var pattern = []
	
	  for (var i = 0, l = sourceChars.length; i < l; i++) {
	    var char = sourceChars[i]
	    if (char === ESCAPE_CHAR) {
	      if (i === l - 1) {
	        throw new Error('InputMask: pattern ends with a raw ' + ESCAPE_CHAR)
	      }
	      char = sourceChars[++i]
	    }
	    else if (char in this.formatCharacters) {
	      if (this.firstEditableIndex === null) {
	        this.firstEditableIndex = patternIndex
	      }
	      this.lastEditableIndex = patternIndex
	      this._editableIndices[patternIndex] = true
	    }
	
	    pattern.push(char)
	    patternIndex++
	  }
	
	  if (this.firstEditableIndex === null) {
	    throw new Error(
	      'InputMask: pattern "' + this.source + '" does not contain any editable characters.'
	    )
	  }
	
	  this.pattern = pattern
	  this.length = pattern.length
	}
	
	/**
	 * @param {Array<string>} value
	 * @return {Array<string>}
	 */
	Pattern.prototype.formatValue = function format(value) {
	  var valueBuffer = new Array(this.length)
	  var valueIndex = 0
	
	  for (var i = 0, l = this.length; i < l ; i++) {
	    if (this.isEditableIndex(i)) {
	      if (this.isRevealingMask &&
	          value.length <= valueIndex &&
	          !this.isValidAtIndex(value[valueIndex], i)) {
	        break
	      }
	      valueBuffer[i] = (value.length > valueIndex && this.isValidAtIndex(value[valueIndex], i)
	                        ? this.transform(value[valueIndex], i)
	                        : this.placeholderChar)
	      valueIndex++
	    }
	    else {
	      valueBuffer[i] = this.pattern[i]
	      // Also allow the value to contain static values from the pattern by
	      // advancing its index.
	      if (value.length > valueIndex && value[valueIndex] === this.pattern[i]) {
	        valueIndex++
	      }
	    }
	  }
	
	  return valueBuffer
	}
	
	/**
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isEditableIndex = function isEditableIndex(index) {
	  return !!this._editableIndices[index]
	}
	
	/**
	 * @param {string} char
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isValidAtIndex = function isValidAtIndex(char, index) {
	  return this.formatCharacters[this.pattern[index]].validate(char)
	}
	
	Pattern.prototype.transform = function transform(char, index) {
	  var format = this.formatCharacters[this.pattern[index]]
	  return typeof format.transform == 'function' ? format.transform(char) : char
	}
	
	function InputMask(options) {
	  if (!(this instanceof InputMask)) { return new InputMask(options) }
	  options = extend({
	    formatCharacters: null,
	    pattern: null,
	    isRevealingMask: false,
	    placeholderChar: DEFAULT_PLACEHOLDER_CHAR,
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	
	  if (options.pattern == null) {
	    throw new Error('InputMask: you must provide a pattern.')
	  }
	
	  if (typeof options.placeholderChar !== 'string' || options.placeholderChar.length > 1) {
	    throw new Error('InputMask: placeholderChar should be a single character or an empty string.')
	  }
	
	  this.placeholderChar = options.placeholderChar
	  this.formatCharacters = mergeFormatCharacters(options.formatCharacters)
	  this.setPattern(options.pattern, {
	    value: options.value,
	    selection: options.selection,
	    isRevealingMask: options.isRevealingMask
	  })
	}
	
	// Editing
	
	/**
	 * Applies a single character of input based on the current selection.
	 * @param {string} char
	 * @return {boolean} true if a change has been made to value or selection as a
	 *   result of the input, false otherwise.
	 */
	InputMask.prototype.input = function input(char) {
	  // Ignore additional input if the cursor's at the end of the pattern
	  if (this.selection.start === this.selection.end &&
	      this.selection.start === this.pattern.length) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  var inputIndex = this.selection.start
	
	  // If the cursor or selection is prior to the first editable character, make
	  // sure any input given is applied to it.
	  if (inputIndex < this.pattern.firstEditableIndex) {
	    inputIndex = this.pattern.firstEditableIndex
	  }
	
	  // Bail out or add the character to input
	  if (this.pattern.isEditableIndex(inputIndex)) {
	    if (!this.pattern.isValidAtIndex(char, inputIndex)) {
	      return false
	    }
	    this.value[inputIndex] = this.pattern.transform(char, inputIndex)
	  }
	
	  // If multiple characters were selected, blank the remainder out based on the
	  // pattern.
	  var end = this.selection.end - 1
	  while (end > inputIndex) {
	    if (this.pattern.isEditableIndex(end)) {
	      this.value[end] = this.placeholderChar
	    }
	    end--
	  }
	
	  // Advance the cursor to the next character
	  this.selection.start = this.selection.end = inputIndex + 1
	
	  // Skip over any subsequent static characters
	  while (this.pattern.length > this.selection.start &&
	         !this.pattern.isEditableIndex(this.selection.start)) {
	    this.selection.start++
	    this.selection.end++
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	    this._historyIndex = null
	  }
	  if (this._lastOp !== 'input' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'input'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to delete from the value based on the current cursor position or
	 * selection.
	 * @return {boolean} true if the value or selection changed as the result of
	 *   backspacing, false otherwise.
	 */
	InputMask.prototype.backspace = function backspace() {
	  // If the cursor is at the start there's nothing to do
	  if (this.selection.start === 0 && this.selection.end === 0) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  // No range selected - work on the character preceding the cursor
	  if (this.selection.start === this.selection.end) {
	    if (this.pattern.isEditableIndex(this.selection.start - 1)) {
	      this.value[this.selection.start - 1] = this.placeholderChar
	    }
	    this.selection.start--
	    this.selection.end--
	  }
	  // Range selected - delete characters and leave the cursor at the start of the selection
	  else {
	    var end = this.selection.end - 1
	    while (end >= this.selection.start) {
	      if (this.pattern.isEditableIndex(end)) {
	        this.value[end] = this.placeholderChar
	      }
	      end--
	    }
	    this.selection.end = this.selection.start
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	  }
	  if (this._lastOp !== 'backspace' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'backspace'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to paste a string of input at the current cursor position or over
	 * the top of the current selection.
	 * Invalid content at any position will cause the paste to be rejected, and it
	 * may contain static parts of the mask's pattern.
	 * @param {string} input
	 * @return {boolean} true if the paste was successful, false otherwise.
	 */
	InputMask.prototype.paste = function paste(input) {
	  // This is necessary because we're just calling input() with each character
	  // and rolling back if any were invalid, rather than checking up-front.
	  var initialState = {
	    value: this.value.slice(),
	    selection: copy(this.selection),
	    _lastOp: this._lastOp,
	    _history: this._history.slice(),
	    _historyIndex: this._historyIndex,
	    _lastSelection: copy(this._lastSelection)
	  }
	
	  // If there are static characters at the start of the pattern and the cursor
	  // or selection is within them, the static characters must match for a valid
	  // paste.
	  if (this.selection.start < this.pattern.firstEditableIndex) {
	    for (var i = 0, l = this.pattern.firstEditableIndex - this.selection.start; i < l; i++) {
	      if (input.charAt(i) !== this.pattern.pattern[i]) {
	        return false
	      }
	    }
	
	    // Continue as if the selection and input started from the editable part of
	    // the pattern.
	    input = input.substring(this.pattern.firstEditableIndex - this.selection.start)
	    this.selection.start = this.pattern.firstEditableIndex
	  }
	
	  for (i = 0, l = input.length;
	       i < l && this.selection.start <= this.pattern.lastEditableIndex;
	       i++) {
	    var valid = this.input(input.charAt(i))
	    // Allow static parts of the pattern to appear in pasted input - they will
	    // already have been stepped over by input(), so verify that the value
	    // deemed invalid by input() was the expected static character.
	    if (!valid) {
	      if (this.selection.start > 0) {
	        // XXX This only allows for one static character to be skipped
	        var patternIndex = this.selection.start - 1
	        if (!this.pattern.isEditableIndex(patternIndex) &&
	            input.charAt(i) === this.pattern.pattern[patternIndex]) {
	          continue
	        }
	      }
	      extend(this, initialState)
	      return false
	    }
	  }
	
	  return true
	}
	
	// History
	
	InputMask.prototype.undo = function undo() {
	  // If there is no history, or nothing more on the history stack, we can't undo
	  if (this._history.length === 0 || this._historyIndex === 0) {
	    return false
	  }
	
	  var historyItem
	  if (this._historyIndex == null) {
	    // Not currently undoing, set up the initial history index
	    this._historyIndex = this._history.length - 1
	    historyItem = this._history[this._historyIndex]
	    // Add a new history entry if anything has changed since the last one, so we
	    // can redo back to the initial state we started undoing from.
	    var value = this.getValue()
	    if (historyItem.value !== value ||
	        historyItem.selection.start !== this.selection.start ||
	        historyItem.selection.end !== this.selection.end) {
	      this._history.push({value: value, selection: copy(this.selection), lastOp: this._lastOp, startUndo: true})
	    }
	  }
	  else {
	    historyItem = this._history[--this._historyIndex]
	  }
	
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	InputMask.prototype.redo = function redo() {
	  if (this._history.length === 0 || this._historyIndex == null) {
	    return false
	  }
	  var historyItem = this._history[++this._historyIndex]
	  // If this is the last history item, we're done redoing
	  if (this._historyIndex === this._history.length - 1) {
	    this._historyIndex = null
	    // If the last history item was only added to start undoing, remove it
	    if (historyItem.startUndo) {
	      this._history.pop()
	    }
	  }
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	// Getters & setters
	
	InputMask.prototype.setPattern = function setPattern(pattern, options) {
	  options = extend({
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	  this.pattern = new Pattern(pattern, this.formatCharacters, this.placeholderChar, options.isRevealingMask)
	  this.setValue(options.value)
	  this.emptyValue = this.pattern.formatValue([]).join('')
	  this.selection = options.selection
	  this._resetHistory()
	}
	
	InputMask.prototype.setSelection = function setSelection(selection) {
	  this.selection = copy(selection)
	  if (this.selection.start === this.selection.end) {
	    if (this.selection.start < this.pattern.firstEditableIndex) {
	      this.selection.start = this.selection.end = this.pattern.firstEditableIndex
	      return true
	    }
	    // Set selection to the first editable, non-placeholder character before the selection
	    // OR to the beginning of the pattern
	    var index = this.selection.start
	    while (index >= this.pattern.firstEditableIndex) {
	      if (this.pattern.isEditableIndex(index - 1) &&
	          this.value[index - 1] !== this.placeholderChar ||
	          index === this.pattern.firstEditableIndex) {
	        this.selection.start = this.selection.end = index
	        break
	      }
	      index--
	    }
	    return true
	  }
	  return false
	}
	
	InputMask.prototype.setValue = function setValue(value) {
	  if (value == null) {
	    value = ''
	  }
	  this.value = this.pattern.formatValue(value.split(''))
	}
	
	InputMask.prototype.getValue = function getValue() {
	  return this.value.join('')
	}
	
	InputMask.prototype.getRawValue = function getRawValue() {
	  var rawValue = []
	  for (var i = 0; i < this.value.length; i++) {
	    if (this.pattern._editableIndices[i] === true) {
	      rawValue.push(this.value[i])
	    }
	  }
	  return rawValue.join('')
	}
	
	InputMask.prototype._resetHistory = function _resetHistory() {
	  this._history = []
	  this._historyIndex = null
	  this._lastOp = null
	  this._lastSelection = copy(this.selection)
	}
	
	InputMask.Pattern = Pattern
	
	module.exports = InputMask


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(4)();
	}


/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** react-maskedinput-ultimate.min.js
 **/